/**
 * processTask模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const processTask = {
  // 查询审批Task
  pageProcessTask(params) {
    return $http.post(`${global.API_URL}/sme/processTask/page`,params);
  },
  // 审批查看
  approvalReview(params) {
    return $http.post(`${global.API_URL}/sme/processTask/approvalReview`,params);
  },
  // 审批详情
  approvalDetail(params) {
    return $http.post(`${global.API_URL}/sme/processTask/approvalDetail`,params);
  },
  //历史流程分页
  historyPage(params) {
    return $http.post(`${global.API_URL}/sme/processTask/historyPage`,params);
  },
   //类型下拉框
  approvalTypes(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/processTask/approvalTypes`,param);
  }
}

export default processTask;



// WEBPACK FOOTER //
// ./src/api/processTask.js